import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import styles from './styles.module.less';
import heartArrow from '../../../../../assets/images/icons/HeartArrow.svg';

type FavoritesModalProps = {
  closeModal: () => void;
};

const FavoritesModal = ({ closeModal }: FavoritesModalProps) => (
  <div className={styles.modal}>
    <img src={heartArrow} />
    <div className={styles.title}>Review Your Favorites</div>
    <div>
      So nice, you&apos;ve got to look twice. Head to the heart in the upper right corner, or Your
      Favorites in the menu bar.
    </div>
    <div className={styles.btns}>
      <ButtonV2
        className={styles.btn}
        variant="secondary"
        onClick={() => {
          // @ts-ignore
          window.location = `${window.location.origin}/favorites/paper`;
        }}
      >
        See Favorites
      </ButtonV2>
      <ButtonV2 variant="primary" onClick={closeModal}>
        Got It
      </ButtonV2>
    </div>
  </div>
);

export default FavoritesModal;
